<oase-header (sidenavEmitter)="sidenavToggle()"></oase-header>

<mat-sidenav #sidenav mode="push" *ngIf="isAuth()" align="start" (open)="closeStartButton.focus()">
  <button mat-mini-fab #closeStartButton (click)="sidenav.close()" class="close">
    <mat-icon class="mat-24">close</mat-icon>
  </button>

  <div class="userinfocont">
    <div class="userinfo">
      <img src="/assets/ktnmilch_logo.png">
    </div>
  </div>

  <p class="errors" *ngIf="fehler" [innerHTML]="fehler.messagehtml"></p>

  <div *ngFor="let menuItemRoot of menuItemList | orderBy: 'reihenfolge'">
    <mat-nav-list>
      <mat-list-item class="root" *ngIf="(menuItemRoot.kinder == null || menuItemRoot.kinder.length == 0)">
        <a *ngIf="menuItemRoot.ziel == '_self'" mat-line routerLink="{{ menuItemRoot.url }}" routerLinkActive="active" (click)="sidenav.close()">
          <mat-icon *ngIf="menuItemRoot.icon">{{ menuItemRoot.icon }}</mat-icon>
          {{ menuItemRoot.sprachschluessel | translate:locale.language }}
        </a>
        <a *ngIf="menuItemRoot.ziel != '_self'" mat-line href="{{ menuItemRoot.url }}" target="{{ menuItemRoot.ziel }}">
          <mat-icon *ngIf="menuItemRoot.icon">{{ menuItemRoot.icon }}</mat-icon>
          {{ menuItemRoot.sprachschluessel | translate:locale.language }}
        </a>
      </mat-list-item>
      <mat-accordion  *ngIf="menuItemRoot.kinder != null && menuItemRoot.kinder.length > 0" class="ebene1">
        <mat-expansion-panel  [disabled]="false">
          <mat-expansion-panel-header>
            <mat-icon *ngIf="menuItemRoot.icon">{{ menuItemRoot.icon }}</mat-icon>
			  <div class="panel-header1">{{ menuItemRoot.sprachschluessel | translate:locale.language }}</div>
          </mat-expansion-panel-header>
          <ng-container *ngFor="let menuItemChild1 of menuItemRoot.kinder | orderBy: 'reihenfolge'">
            <mat-list-item *ngIf="(menuItemChild1.kinder == null || menuItemChild1.kinder.length == 0)">
              <a *ngIf="menuItemChild1.ziel == '_self'" mat-line routerLink="{{ menuItemChild1.url }}" routerLinkActive="active" (click)="sidenav.close()">
                <mat-icon *ngIf="menuItemChild1.icon">{{ menuItemChild1.icon }}</mat-icon>
                {{ menuItemChild1.sprachschluessel | translate:locale.language }}
              </a>
              <a *ngIf="menuItemChild1.ziel != '_self'" mat-line href="{{ menuItemChild1.url }}" target="{{ menuItemChild1.ziel }}">
                <mat-icon *ngIf="menuItemChild1.icon">{{ menuItemChild1.icon }}</mat-icon>
                {{ menuItemChild1.sprachschluessel | translate:locale.language }}
              </a>
            </mat-list-item>
            <mat-accordion  *ngIf="menuItemChild1.kinder != null && menuItemChild1.kinder.length > 0" class="ebene2">
              <mat-expansion-panel  [disabled]="false">
                <mat-expansion-panel-header>
                  <mat-icon *ngIf="menuItemChild1.icon">{{ menuItemChild1.icon }}</mat-icon>
                  {{ menuItemChild1.sprachschluessel | translate:locale.language }}
                </mat-expansion-panel-header>
                <ng-container *ngFor="let menuItemChild2 of menuItemChild1.kinder | orderBy: 'reihenfolge'">
                  <mat-list-item *ngIf="(menuItemChild2.kinder == null || menuItemChild2.kinder.length == 0)">
                    <a *ngIf="menuItemChild2.ziel == '_self'" mat-line routerLink="{{ menuItemChild2.url }}" routerLinkActive="active" (click)="sidenav.close()">
                      <mat-icon *ngIf="menuItemChild2.icon">{{ menuItemChild2.icon }}</mat-icon>
                      {{ menuItemChild2.sprachschluessel | translate:locale.language }}
                    </a>
                    <a *ngIf="menuItemChild2.ziel != '_self'" mat-line href="{{ menuItemChild2.url }}" target="{{ menuItemChild2.ziel }}">
                      <mat-icon *ngIf="menuItemChild2.icon">{{ menuItemChild2.icon }}</mat-icon>
                      {{ menuItemChild2.sprachschluessel | translate:locale.language }}
                    </a>
                  </mat-list-item>
                  <mat-accordion  *ngIf="menuItemChild2.kinder != null && menuItemChild1.kinder.length > 0" class="ebene3">
                    <mat-expansion-panel  [disabled]="false">
                      <mat-expansion-panel-header>
                        <mat-icon *ngIf="menuItemChild2.icon">{{ menuItemChild2.icon }}</mat-icon>
                        {{ menuItemChild2.sprachschluessel | translate:locale.language }}
                      </mat-expansion-panel-header>
                      <ng-container *ngFor="let menuItemChild3 of menuItemChild2.kinder | orderBy: 'reihenfolge'">
                        <mat-list-item *ngIf="(menuItemChild3.kinder == null || menuItemChild3.kinder.length == 0)">
                          <a *ngIf="menuItemChild3.ziel == '_self'" mat-line routerLink="{{ menuItemChild3.url }}" routerLinkActive="active" (click)="sidenav.close()">
                            <mat-icon *ngIf="menuItemChild3.icon">{{ menuItemChild3.icon }}</mat-icon>
                            {{ menuItemChild3.sprachschluessel | translate:locale.language }}
                          </a>
                          <a *ngIf="menuItemChild3.ziel != '_self'" mat-line href="{{ menuItemChild3.url }}" target="{{ menuItemChild3.ziel }}">
                            <mat-icon *ngIf="menuItemChild3.icon">{{ menuItemChild3.icon }}</mat-icon>
                            {{ menuItemChild3.sprachschluessel | translate:locale.language }}
                          </a>
                        </mat-list-item>
                        <mat-accordion  *ngIf="menuItemChild3.kinder != null && menuItemChild1.kinder.length > 0" class="ebene4">
                          <mat-expansion-panel  [disabled]="false">
                            <mat-expansion-panel-header>
                              <mat-icon *ngIf="menuItemChild3.icon">{{ menuItemChild3.icon }}</mat-icon>
								{{ menuItemChild3.sprachschluessel | translate:locale.language }}
                            </mat-expansion-panel-header>
                            <ng-container *ngFor="let menuItemChild4 of menuItemChild3.kinder | orderBy: 'reihenfolge'">
                              <mat-list-item *ngIf="(menuItemChild4.kinder == null || menuItemChild4.kinder.length == 0)">
                                <a *ngIf="menuItemChild4.ziel == '_self'" mat-line routerLink="{{ menuItemChild4.url }}" routerLinkActive="active" (click)="sidenav.close()">
                                  <mat-icon *ngIf="menuItemChild4.icon">{{ menuItemChild4.icon }}</mat-icon>
                                  {{ menuItemChild4.sprachschluessel | translate:locale.language }}
                                </a>
                                <a *ngIf="menuItemChild4.ziel != '_self'" mat-line href="{{ menuItemChild4.url }}" target="{{ menuItemChild4.ziel }}">
                                  <mat-icon *ngIf="menuItemChild4.icon">{{ menuItemChild4.icon }}</mat-icon>
                                  {{ menuItemChild4.sprachschluessel | translate:locale.language }}
                                </a>
                              </mat-list-item>
                              <mat-accordion  *ngIf="menuItemChild4.kinder != null && menuItemChild1.kinder.length > 0" class="ebene5">
                                <mat-expansion-panel  [disabled]="false">
                                  <mat-expansion-panel-header>
                                    <mat-icon *ngIf="menuItemChild4.icon">{{ menuItemChild4.icon }}</mat-icon>
                                    {{ menuItemChild4.sprachschluessel | translate:locale.language }}
                                  </mat-expansion-panel-header>
                                  <ng-container *ngFor="let menuItemChild5 of menuItemChild4.kinder | orderBy: 'reihenfolge'">
                                    <mat-list-item *ngIf="(menuItemChild5.kinder == null || menuItemChild5.kinder.length == 0)">
                                      <a *ngIf="menuItemChild5.ziel == '_self'" mat-line routerLink="{{ menuItemChild5.url }}" routerLinkActive="active" (click)="sidenav.close()">
                                        <mat-icon *ngIf="menuItemChild5.icon">{{ menuItemChild5.icon }}</mat-icon>
                                        {{ menuItemChild5.sprachschluessel | translate:locale.language }}
                                      </a>
                                      <a *ngIf="menuItemChild5.ziel != '_self'" mat-line href="{{ menuItemChild5.url }}" target="{{ menuItemChild5.ziel }}">
                                        <mat-icon *ngIf="menuItemChild5.icon">{{ menuItemChild5.icon }}</mat-icon>
                                        {{ menuItemChild5.sprachschluessel | translate:locale.language }}
                                      </a>
                                    </mat-list-item>
                                  </ng-container>
                                </mat-expansion-panel>
                              </mat-accordion>
                            </ng-container>
                          </mat-expansion-panel>
                        </mat-accordion>
                      </ng-container>
                    </mat-expansion-panel>
                  </mat-accordion>
                </ng-container>
              </mat-expansion-panel>
            </mat-accordion>
          </ng-container>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-nav-list>
  </div>

</mat-sidenav>

